import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-address',
  templateUrl: './view-address.component.html',
  styleUrls: ['./view-address.component.scss'],
})
export class ViewAddressComponent implements OnInit {
  @Input() address: string;
  @Input() address2?: string;
  @Input() city: string;
  @Input() state?: string;
  @Input() zip: string;
  @Input() linkToGoogleMaps = true;

  googleMapsUrl: string;

  constructor() {}

  ngOnInit(): void {
    if (this.linkToGoogleMaps) {
      this.generateGoogleMapsUrl();
    }
  }

  generateGoogleMapsUrl(): void {
    const fullAddress = [
      this.address,
      this.address2,
      this.city,
      this.state || 'MD',
      this.zip,
    ]
      .filter(Boolean) // Remove undefined or empty values
      .join(', ');

    this.googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      fullAddress
    )}`;
  }
}
